import * as tslib_1 from "tslib";
import { HttpException } from "./HttpException";
import { parseUrl } from "../misc";
import "./xdr";
var HttpClient = /** @class */ (function () {
    function HttpClient(options) {
        this.options = tslib_1.__assign({}, this.getDefaultOptions(), { options: options });
    }
    HttpClient.prototype.getDefaultOptions = function () {
        return {
            retryCount: 3,
            retryTimeout: 1000
        };
    };
    HttpClient.prototype.send = function (url, settings) {
        var retryCount = this.options.retryCount;
        var timeout = this.options.retryTimeout;
        if (!settings)
            settings = {};
        return new Promise(function (resolve, reject) {
            $.ajax(tslib_1.__assign({ url: url, method: "GET", headers: { Accept: "application/json" }, dataType: "json", crossDomain: HttpClient.isCrossDomainRequest(url) }, settings, { success: resolve, error: function (xhr, textStatus, errorThrown) {
                    var _this = this;
                    if (--retryCount && (xhr.status !== 400 && xhr.status !== 404 && xhr.status !== 500)) {
                        setTimeout(function () { return jQuery.ajax(_this); }, timeout);
                    }
                    else {
                        reject(new HttpException(xhr.status, textStatus, errorThrown));
                    }
                } }));
        });
    };
    HttpClient.prototype.get = function (url, parameters) {
        var settings = parameters
            ? { data: $.param(parameters) }
            : {};
        return this.send(url, settings);
    };
    HttpClient.prototype.post = function (url, parameters) {
        var settings = {
            method: "POST",
            processData: false,
            contentType: "application/json"
        };
        if (parameters)
            settings.data = JSON.stringify(parameters);
        return this.send(url, settings);
    };
    HttpClient.isCrossDomainRequest = function (url) {
        var uri = parseUrl(url);
        var location = document.location;
        return location.protocol !== uri.protocol
            || location.host !== uri.host;
    };
    return HttpClient;
}());
export { HttpClient };
//# sourceMappingURL=HttpClient.js.map


//////////////////
// WEBPACK FOOTER
// ../~/xm-ui/http/HttpClient.js
// module id = 48
// module chunks = 1